import { render, staticRenderFns } from "./ModalDetail.vue?vue&type=template&id=d61835e4&scoped=true"
import script from "./ModalDetail.vue?vue&type=script&lang=js"
export * from "./ModalDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalDetail.vue?vue&type=style&index=0&id=d61835e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61835e4",
  null
  
)

export default component.exports